<template>
  <b-modal
    :active="active"
    has-modal-card
    @close="$emit('close')"
    :can-cancel="['escape', 'x', 'outside']"
  >
    <div class="modal-card">
      <form @submit.prevent="validateBeforeSubmit">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('compCoreTagsSelectorModal.label-1') }}
          </p>
        </header>
        <section class="modal-card-body">
          <tags-input v-model="tags" :required="true" />
          <hr />
          <nav class="level">
            <div class="level-left"></div>
            <div class="buttons level-right">
              <b-button
                class="button"
                @click="$emit('close')"
                icon-left="close"
              >
                {{ $t('cancel') }}
              </b-button>
              <button type="submit" class="button is-primary">
                <b-icon size="is-small" icon="plus" />
                <span> {{ $t('add') }} </span>
              </button>
            </div>
          </nav>
        </section>
      </form>
    </div>
  </b-modal>
</template>

<script>
import { useGHGIStore } from '@/stores/ghgi.js'

export default {
  name: 'TagsSelectorModal',
  $_veeValidate: {
    validator: 'new'
  },
  setup () {
    const ghgiStore = useGHGIStore()
    return { ghgiStore }
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    module: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    'tags-input': () => import('@/components/core/TagsInput.vue')
  },
  data () {
    return {
      tags: []
    }
  },
  methods: {
    validateBeforeSubmit: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.ghgiStore.addTags({
            module: this.module,
            items: this.items,
            tags: this.tags
          })
          this.tags = []
          this.$emit('tags-added')
          this.$emit('close')
        }
      })
    }
  }
}
</script>
